import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";
import {SubscriptionsSummary} from "../../../models/reports/admin-report/subscription-summary.model";

/**
 * @class SubscriptionsSummaryPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<SubscriptionsSummary>}
 */
export class SubscriptionsSummaryPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/subscriptions-summary';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SubscriptionsSummary}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SubscriptionsSummary(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<AverageDailyRate[]>}
     */
    getGraphData(params = {}, property = null) {

        const url = this.url() + '/graf-data';

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/subscription-summary.service.js